import { createRequest, throwResErrors, createHeaders } from "./requestUtil";

export function setTutorialInfo(profileId, data) {
	let url = `api/profile/profiles/${profileId}/tutorial-flags`;
	return createRequest()
		.post(url, data, { headers: createHeaders() })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
}
